import { usePublicReport, useReports, useTeam } from '@round/creatorbase-helpers/api-hooks';
import usePublicReportId from 'Modules/Plans/PublicReports/usePublicReportId';

export default function usePublicReportData() {
    const publicReportId = usePublicReportId();

    const { data: report, status } = usePublicReport(publicReportId, { enabled: !!publicReportId });

    const reportsQuery = useReports({ public_report_id: publicReportId ?? undefined }, { enabled: !!publicReportId });
    const teamId = reportsQuery.data?.results[0]?.team_id;
    // currency_id accompanies total_cost on the public report itself (both gated on include_cost),
    // not on the reports list endpoint.
    const currencyId = report?.currency_id ?? null;
    const { data: team, status: teamStatus } = useTeam(
        teamId,
        {},
        { enabled: typeof teamId === 'number' },
        publicReportId ?? undefined
    );

    return {
        data: report ?? null,
        status,
        currencyId,
        team: { data: team ?? null, status: teamStatus },
    };
}
